import { Component, Element, Event, EventEmitter, h, Host, Prop } from "@stencil/core";
import { ChevronDown, ChevronUp } from "../../icons";
import { TableRowWithId } from "../table-interfaces";
import { SortData, SortDirection } from "../table-types";

enum Directions {
    Asc = "asc",
    Desc = "desc",
    None = ""
}

@Component({
    tag: "uic-table-head-sort",
    styleUrl: "table-head-sort.scss",
    shadow: false
})
export class TableSort {
    @Element() domElement: HTMLUicTableHeadSortElement;
    /** This is the name of the sort field used in the sort click event */
    @Prop() readonly sortField: string;
    /** indicates in which direction the data is already sorted. This has to be empty when it is not sorted yet.
     *  Setting this does not trigger the sorting event. Clicking the button will update this attribute. */
    // eslint-disable-next-line
    @Prop({ reflect: true, mutable: true }) sortedDirection: SortDirection = "";

    /** callback function used to sort the column */
    @Prop() readonly customComparator: (a: TableRowWithId, b: TableRowWithId) => number;

    /** when the sort Button is clicked it emits the asc or desc name  */
    @Event({
        eventName: "uicTableSort",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    sortEvent: EventEmitter;

    private sort(): void {
        switch (this.sortedDirection) {
            case Directions.Asc:
                this.sortedDirection = Directions.Desc;
                break;
            case Directions.Desc:
                this.sortedDirection = Directions.None;
                break;
            default:
                this.sortedDirection = Directions.Asc;
        }
        const sortCriterion: SortData = {
            sortProperty: this.sortField,
            direction: this.sortedDirection,
            customComparator: this.customComparator
        };

        this.sortEvent.emit(sortCriterion);
        const allSorters = this.domElement.closest("tr").querySelectorAll("uic-table-head-sort");
        [].forEach.call(allSorters, (element: HTMLUicTableHeadSortElement) => {
            if (element.isEqualNode(this.domElement)) {
                return;
            }
            element.sortedDirection = Directions.None;
        });
    }

    render() {
        const baseClass = "uic-table-head-sort";
        return (
            <Host class={baseClass} onClick={() => this.sort()}>
                <slot />
                &nbsp;
                <span class={`${baseClass}__icon`}>
                    {ChevronUp()}
                    {ChevronDown()}
                </span>
            </Host>
        );
    }
}
